import ValueDeserializerInterface from "./ValueDeserializerInterface"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import GameDeserializer from "../GameDeserializer"
import DivisionValue from "../../Model/Value/DivisionValue"

export default class DivisionValueDeserializer implements ValueDeserializerInterface {
  private serializer: GameDeserializer | undefined = undefined
  public supports(payload: SerializedValueType): boolean {
    return payload.type === "division"
  }

  public deserialize(payload: SerializedValueType): DivisionValue {
    if (this.serializer === undefined) {
      throw new Error("Value deserializer is not implemented")
    }

    return new DivisionValue(
      this.serializer.deserializeValue(
        payload.payload.dividend as SerializedValueType,
      ),
      payload.payload.sign,
      this.serializer.deserializeValue(
        payload.payload.divisor as SerializedValueType,
      ),
    )
  }

  public setSerializer(serializer: GameDeserializer): void {
    this.serializer = serializer
  }
}
